import React from "react";

const BoldString = str => <b>{str}</b>;
const highlightSearch = (str, word) => {
	const indexOfWord = str.toLowerCase().indexOf(word.toLowerCase());
	return [
		str.slice(0, indexOfWord),
		BoldString(str.slice(indexOfWord, indexOfWord + word.length)),
		str.slice(indexOfWord + word.length),
	];
};

const truncateString = (str, word, length = 30) => {
	const location = str?.toLowerCase()?.indexOf(word);

	if (location < 0) {
		return str.length > length ? `${str.slice(0, length)}...` : str;
	}
	if (str.length <= length) {
		return highlightSearch(str, word);
	}
	const leftCount = str.substring(0, location).length;
	const rightCount = str.substring(location, str.length - 1).length;

	if (leftCount <= length) {
		return highlightSearch(`${str.slice(0, length)}...`, word);
	}

	if (rightCount <= length) {
		return highlightSearch(`...${str.slice(str.length - length, str.length)}`, word);
	}
	return highlightSearch(`...${str.slice(location - length / 2, location + length / 2)}...`, word);
};

export default truncateString;
export { truncateString };
